import { TaskStatus } from 'constants/tasks';

const ScheduleClosingLocation = {
  TITLE_COMPANY: 'TitleCompany',
  PRIMARY_RESIDENCE: 'PrimaryResidence',
  OTHER: 'Other',
};

export const ScheduleClosingLocationLabel = {
  [ScheduleClosingLocation.TITLE_COMPANY]: 'Title Company',
  [ScheduleClosingLocation.PRIMARY_RESIDENCE]: 'Primary Residence',
  [ScheduleClosingLocation.OTHER]: 'Other',
};

export const ScheduleClosingTaskStatusLabel = {
  [TaskStatus.SUBMITTED]: 'Pending Review',
  [TaskStatus.APPROVED]: 'Approved',
  [TaskStatus.REJECTED]: 'Rejected',
};

export const StatusChipColorMap = {
  [TaskStatus.SUBMITTED]: 'warning',
  [TaskStatus.APPROVED]: 'success',
  [TaskStatus.REJECTED]: 'error',
};

export const DEFAULT_CHIP_COLOR = 'default';
